import styled from '@emotion/styled';

import theme from '@vromo/ui/components/theme';

export const UnitPicker = styled.div`
    padding: 10px;
    border-radius: 3px;
    background-color: ${theme.lightGrey};
    border: 1px solid ${theme.lightGrey};
    display: flex;
    align-items: center;
`;
